module.exports = __webpack_public_path__ + "i18n/ko.a4fe8d129d14bbf56a948c65a24b1645.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ko.json
// module id = 1001
// module chunks = 60